module.exports = __webpack_public_path__ + "static/img/crossref-logo.c45cc054.svg";